import { render } from "./NewBar.vue?vue&type=template&id=6b49c5d6"
import script from "./NewBar.vue?vue&type=script&lang=js"
export * from "./NewBar.vue?vue&type=script&lang=js"
script.render = render

export default script